<template>
    <div>
        <div class="md-layout">
            <div class="md-layout-item md-size-30">
                <md-tabs md-swipeable md-active-tab="tab-ranks" md-alignment="centered" @md-changed="tabChanged">
                  <md-tab id="tab-events" md-icon="list"/>
                  <md-tab id="tab-ranks" :md-icon="require('../assets/Hand_rank_icon.svg')" />
                  <md-tab id="tab-blinds" md-icon="local_atm"/>
                </md-tabs>
                <div :class="{'leftVisible': selectedTab === 'tab-events', 'leftHidden': selectedTab !== 'tab-events'}">
                  <gameEvents />
                </div>
                <div :class="{'leftVisible': selectedTab === 'tab-ranks', 'leftHidden': selectedTab !== 'tab-ranks'}">
                  <md-card class="cardRankings left">
                      <md-card-media-cover>
                          <md-card-media>
                              <img class="cardRankingImg" src="../assets/Royal_Flush.svg">
                          </md-card-media>
                          <md-card-area>
                              <md-card-header>
                                  <span class="md-subhead cardRankingTitle">1. Royal Flush</span>
                              </md-card-header>
                          </md-card-area>
                      </md-card-media-cover>
                  </md-card>
                  <md-card class="cardRankings right">
                      <md-card-media-cover>
                          <md-card-media>
                              <img class="cardRankingImg" src="../assets/Straight_Flush.svg">
                          </md-card-media>
                          <md-card-area>
                              <md-card-header>
                                  <span class="md-subhead cardRankingTitle">2. Straight Flush</span>
                              </md-card-header>
                          </md-card-area>
                      </md-card-media-cover>
                  </md-card>
                  <md-card class="cardRankings left">
                      <md-card-media-cover>
                          <md-card-media>
                              <img class="cardRankingImg" src="../assets/Four_Of_A_Kind.svg">
                          </md-card-media>
                          <md-card-area>
                              <md-card-header>
                                  <span class="md-subhead cardRankingTitle">3. Four of a Kind</span>
                              </md-card-header>
                          </md-card-area>
                      </md-card-media-cover>
                  </md-card>
                  <md-card class="cardRankings right">
                      <md-card-media-cover>
                          <md-card-media>
                              <img class="cardRankingImg" src="../assets/Full_House.svg">
                          </md-card-media>
                          <md-card-area>
                              <md-card-header>
                                  <span class="md-subhead cardRankingTitle">4. Full House</span>
                              </md-card-header>
                          </md-card-area>
                      </md-card-media-cover>
                  </md-card>
                  <md-card class="cardRankings left">
                      <md-card-media-cover>
                          <md-card-media>
                              <img class="cardRankingImg" src="../assets/Flush.svg">
                          </md-card-media>
                          <md-card-area>
                              <md-card-header>
                                  <span class="md-subhead cardRankingTitle">5. Flush</span>
                              </md-card-header>
                          </md-card-area>
                      </md-card-media-cover>
                  </md-card>
                  <md-card class="cardRankings right">
                      <md-card-media-cover>
                          <md-card-media>
                              <img class="cardRankingImg" src="../assets/Straight.svg">
                          </md-card-media>
                          <md-card-area>
                              <md-card-header>
                                  <span class="md-subhead cardRankingTitle">6. Straight</span>
                              </md-card-header>
                          </md-card-area>
                      </md-card-media-cover>
                  </md-card>
                  <md-card class="cardRankings left">
                      <md-card-media-cover>
                          <md-card-media>
                              <img class="cardRankingImg" src="../assets/Three_of_a_kind.svg">
                          </md-card-media>
                          <md-card-area>
                              <md-card-header>
                                  <span class="md-subhead cardRankingTitle">7. Three of a Kind</span>
                              </md-card-header>
                          </md-card-area>
                      </md-card-media-cover>
                  </md-card>
                  <md-card class="cardRankings right">
                      <md-card-media-cover>
                          <md-card-media>
                              <img class="cardRankingImg" src="../assets/Two_Pair.svg">
                          </md-card-media>
                          <md-card-area>
                              <md-card-header>
                                  <span class="md-subhead cardRankingTitle">8. Two Pair</span>
                              </md-card-header>
                          </md-card-area>
                      </md-card-media-cover>
                  </md-card>
                  <md-card class="cardRankings left">
                      <md-card-media-cover>
                          <md-card-media>
                              <img class="cardRankingImg" src="../assets/One_Pair.svg">
                          </md-card-media>
                          <md-card-area>
                              <md-card-header>
                                  <span class="md-subhead cardRankingTitle">9. One Pair</span>
                              </md-card-header>
                          </md-card-area>
                      </md-card-media-cover>
                  </md-card>
                  <md-card class="cardRankings right">
                      <md-card-media-cover>
                          <md-card-media>
                              <img class="cardRankingImg" src="../assets/High_Card.svg">
                          </md-card-media>
                          <md-card-area>
                              <md-card-header>
                                  <span class="md-subhead cardRankingTitle">10. High Card</span>
                              </md-card-header>
                          </md-card-area>
                      </md-card-media-cover>
                  </md-card>
                </div>
                <div id="divBlinds" :class="{'leftVisible': selectedTab === 'tab-blinds', 'leftHidden': selectedTab !== 'tab-blinds'}">
                  <gameBlinds />
                </div>
            </div>
            <div class="md-layout-item md-size-40 centerColumn">
                <md-card class="cardTimer">
                    <md-card-header>
                        <md-card-header-text>
                            <span class="md-subheading">Level Timer</span>
                        </md-card-header-text>
                    </md-card-header>
                    <md-card-area>
                        <span class="md-display-4 timerText">{{gameTimer.timeRemaining}}</span>
                    </md-card-area>
                    <md-card-actions style="justify-content: center">
                        <md-button class="md-icon-button md-accent timerButton" :disabled="(loading.eventTimer || gameTimer.isFinished || !gameTimer.rwdButton || shared.active)" @click="buttonClick(gameEventTypes.previous)">
                            <md-icon class="timerButtonIcon">skip_previous</md-icon>
                        </md-button>
                        <md-button class="md-icon-button md-accent timerButton" :disabled="(loading.eventTimer || gameTimer.isFinished || shared.active)" v-if="gameTimer.playButton" @click="buttonClick(gameEventTypes.play)">
                            <md-icon class="timerButtonIcon">play_arrow</md-icon>
                        </md-button>
                        <md-button class="md-icon-button md-accent timerButton" :disabled="(loading.eventTimer || gameTimer.isFinished || shared.active)" v-else @click="buttonClick(gameEventTypes.pause)">
                            <md-icon class="timerButtonIcon">pause</md-icon>
                        </md-button>
                        <md-button class="md-icon-button md-accent timerButton" :disabled="(loading.eventTimer || gameTimer.isFinished || !gameTimer.fwdButton || shared.active)" @click="buttonClick(gameEventTypes.next)">
                            <md-icon class="timerButtonIcon">skip_next</md-icon>
                        </md-button>
                    </md-card-actions>
                </md-card>
                <md-card class="cardBlindsCurrent">
                    <md-card-header>
                        <md-card-header-text>
                            <span class="md-subheading">Current Blinds</span>
                        </md-card-header-text>
                    </md-card-header>
                    <md-card-area>
                        <span class="md-display-4 currentBlindText">{{gameTimer.blindCurrent}}</span>
                    </md-card-area>
                </md-card>
                <md-card class="cardBlindsPrevious">
                    <md-card-header>
                        <md-card-header-text>
                            <span class="md-subheading">Previous Blinds</span>
                        </md-card-header-text>
                    </md-card-header>
                    <md-card-area>
                        <span class="md-display-3 subBlindText">{{gameTimer.blindPrevious}}</span>
                    </md-card-area>
                </md-card>
                <md-card class="cardBlindsNext">
                    <md-card-header>
                        <md-card-header-text>
                            <span class="md-subheading">Next Blinds</span>
                        </md-card-header-text>
                    </md-card-header>
                    <md-card-area>
                        <span class="md-display-3 subBlindText">{{gameTimer.blindNext}}</span>
                    </md-card-area>
                </md-card>
                <div class='md-display-2 divBlindMessage' v-if="gameTimer.blindMessage !== null">{{gameTimer.blindMessage}}</div>
            </div>
            <div class="md-layout-item md-size-30 rightColumn">
                <md-table md-card class="cardPlayers">
                    <md-table-toolbar class="cardHeadingToolbar">
                        <h1 class="md-subheading">Players</h1>
                    </md-table-toolbar>
                    <md-table-row>
                        <md-table-head class="md-title playerHeader"></md-table-head>
                        <md-table-head class="md-title playerHeader">Player</md-table-head>
                        <md-table-head class="md-title playerHeader">Place</md-table-head>
                        <md-table-head class="md-title playerHeader">Points</md-table-head>
                    </md-table-row>
                    <md-table-row v-for="player in gameTimerPlayers" :key="player.id">
                        <md-table-cell class="cellPlayer">
                            <md-button class="md-icon-button md-accent playerButton" v-if="player.stillIn && gameTimer.canTopup && !shared.active" @click="showTopupDialog(player)">
                                <md-icon class="playerButtonIcon">monetization_on</md-icon>
                            </md-button>
                            <md-button class="md-icon-button md-accent playerButton" v-if="player.stillIn && !shared.active" @click="showKnockoutDialog(player)">
                                <md-icon class="playerButtonIcon">remove_circle</md-icon>
                            </md-button>
                        </md-table-cell>
                        <md-table-cell class="md-display-1 cellPlayerName cellPlayer">{{player.n}}</md-table-cell>
                        <md-table-cell class="md-display-1 cellPlayer" v-if="player.stillIn"></md-table-cell>
                        <md-table-cell class="md-display-1 cellPlayer" v-else>{{player.place}}</md-table-cell>
                        <md-table-cell class="md-display-1 cellPlayer" v-if="player.stillIn"></md-table-cell>
                        <md-table-cell class="md-display-1 cellPlayer" v-else>{{player.points}}</md-table-cell>
                    </md-table-row>
                </md-table>
                <br>
                <md-table md-card class="cardPayouts">
                    <md-table-toolbar class="cardHeadingToolbar">
                        <h1 class="md-subheading">Payouts</h1>
                    </md-table-toolbar>
                    <md-table-row>
                        <md-table-cell class="md-display-1 payoutCell">Total:</md-table-cell>
                        <md-table-cell class="md-display-1 payoutCell">{{'$' + gameTimer.totalPot}}</md-table-cell>
                    </md-table-row>
                    <md-table-row v-for="(payout, index) in gameTimer.payouts" :key="index">
                        <md-table-cell class="md-display-1 payoutCell" v-if="index === 0">First:</md-table-cell>
                        <md-table-cell class="md-display-1 payoutCell" v-if="index === 1">Second:</md-table-cell>
                        <md-table-cell class="md-display-1 payoutCell" v-if="index === 2">Third:</md-table-cell>
                        <md-table-cell class="md-display-1 payoutCell">{{'$' + payout}}</md-table-cell>
                    </md-table-row>
                </md-table>
                <md-table md-card class="cardChipstacks">
                    <md-table-toolbar class="cardHeadingToolbar">
                        <h1 class="md-subheading">Chips</h1>
                    </md-table-toolbar>
                    <md-table-row>
                        <md-table-cell class="md-display-1 payoutCell">Total:</md-table-cell>
                        <md-table-cell class="md-display-1 payoutCell">{{gameTimer.totalChipsFormatted}}</md-table-cell>
                    </md-table-row>
                    <md-table-row>
                        <md-table-cell class="md-display-1 payoutCell">Average:</md-table-cell>
                        <md-table-cell class="md-display-1 payoutCell">{{gameTimer.averageChips}}</md-table-cell>
                    </md-table-row>
                </md-table>
            </div>
        </div>
        <md-dialog :md-active.sync="showPlayerKODialog">
            <md-dialog-title>{{KOPlayer.n + ' knocked out'}}</md-dialog-title>
            <md-dialog-content>
                <md-field>
                    <label for="selectKOByPlayer">By</label>
                    <md-select v-model="KOByPlayerId" name="selectKOByPlayer" id="selectKOByPlayer" v-if="KOPlayer !== {}">
                        <md-option v-for="player in activePlayers" :key="player.id" :value="player.id">{{player.n}}</md-option>
                    </md-select>
                </md-field>
                <md-switch v-model="doesRebuy" v-if="gameTimer.canRebuy">and rebuys</md-switch>
            </md-dialog-content>
            <md-dialog-actions>
                <md-button class="md-accent" @click="showPlayerKODialog = false">Cancel</md-button>
                <md-button @click="buttonClick(gameEventTypes.knockout)" :disabled="(KOByPlayerId=='' || KOByPlayerId=='')" class="md-accent">Save</md-button>
            </md-dialog-actions>
        </md-dialog>
        <md-dialog-confirm :md-active.sync="showTopupConfirm" :md-title="'Topup ' + topupPlayer.n"
            :md-content="'Are you sure you want to topup ' + topupPlayer.n + '?'"
            md-confirm-text="Yes" md-cancel-text="No" @md-confirm="buttonClick(gameEventTypes.topup)"
        />
    </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import { gameEventTypes } from '../constants.js'
import gameEvents from './Game-Events'
import gameBlinds from './Game-Blinds'

export default {
  name: 'GameTimer',
  components: {
    gameEvents,
    gameBlinds
  },
  data: function () {
    return {
      bypass: false,
      gameEventTypes: gameEventTypes,
      showPlayerKODialog: false,
      showTopupConfirm: false,
      KOPlayer: {},
      topupPlayer: {},
      KOByPlayerId: '',
      activePlayers: [],
      doesRebuy: false,
      selectedTab: 'tab-ranks'
    }
  },
  created: function () {
    window.addEventListener('keyup', this.onKeyUp)
  },
  beforeDestroy: function () {
    window.removeEventListener('keyup', this.onKeyUp)
  },
  computed: {
    ...mapState(['gameTimerPlayers', 'activeGameId', 'gameTimer', 'loading', 'activeSeasonId', 'shared']),
    ...mapGetters(['gameTimerActivePlayers', 'gameTimerGameBroadcast'])
  },
  methods: {
    buttonClick: function (eventType, payload = null) {
      switch (eventType) {
        case gameEventTypes.play:
        case gameEventTypes.pause:
        case gameEventTypes.previous:
        case gameEventTypes.next:
          this.$store.dispatch('gameEventAdd', {type: eventType, seasonId: this.activeSeasonId, gameId: this.activeGameId, broadcast: this.gameTimerGameBroadcast})
          break
        case gameEventTypes.knockout:
          this.$store.dispatch('gameEventAdd', {type: eventType, seasonId: this.activeSeasonId, gameId: this.activeGameId, playerId1: this.KOPlayer.id, playerId2: this.KOByPlayerId, rebuy: this.doesRebuy, broadcast: this.gameTimerGameBroadcast})
          this.showPlayerKODialog = false
          break
        case gameEventTypes.topup:
          this.$store.dispatch('gameEventAdd', {type: eventType, seasonId: this.activeSeasonId, gameId: this.activeGameId, playerId1: this.topupPlayer.id, broadcast: this.gameTimerGameBroadcast})
          break
        default:
          break
      }
    },
    showKnockoutDialog: function (player) {
      this.KOByPlayerId = ''
      this.doesRebuy = false
      this.KOPlayer = player
      let players = []
      for (let index = 0; index < this.gameTimerPlayers.length; index++) {
        const player = this.gameTimerPlayers[index]
        if (player.stillIn && player.id !== this.KOPlayer.id) {
          players.push(player)
        }
      }
      this.activePlayers = players
      this.showPlayerKODialog = true
    },
    showTopupDialog: function (player) {
      this.topupPlayer = player
      this.showTopupConfirm = true
    },
    onKeyUp: function (event) {
      if (!(this.loading.eventTimer || this.gameTimer.isFinished)) {
        switch (event.key) {
          case 'MediaPlayPause':
            if (this.gameTimer.playButton) {
              this.buttonClick(gameEventTypes.play)
            } else {
              this.buttonClick(gameEventTypes.pause)
            }
            break
          case 'MediaTrackNext':
            if (!this.gameTimer.isLastLevel) {
              this.buttonClick(gameEventTypes.next)
            }
            break
          case 'MediaTrackPrevious':
            if (!this.gameTimer.isFirstLevel) {
              this.buttonClick(gameEventTypes.previous)
            }
            break
          default:
            break
        }
      }
    },
    tabChanged: function (tabId) {
      this.selectedTab = tabId
    }
  }
}
</script>

<style lang="scss">
  .cardRankings.left {
    width: 45%;
    height: 9vw;
    float: left;
    padding-top: 1.04vw;
    margin-right: 0px;
    box-shadow: none;
  }
  .cardRankings.right {
    width: 45%;
    height: 9vw;
    float: right;
    padding-top: 1.04vw;
    margin-left: 0px;
    margin-right: 0px;
    box-shadow: none;
  }
  .cardRankingTitle {
    line-height: 1.5vw !important;
    text-align: center;
    position: relative;
    top: 2.4vw;
    font-size: 1.2vw !important;
  }
  .centerColumn {
    padding-left: 1.04vw;
    padding-right: 1.04vw;
  }
  .cardTimer {
    width: 100%;
    padding-top: 1.04vw;
    margin: 0px !important;
    box-shadow: none;
    text-align: center;
  }
  .timerText {
    font-size: 5.9vw;
    line-height: 6vw;
    vertical-align: top;
  }
  .timerButton {
    width: 3.5vw;
    height: 3.5vw;
    margin-left: 0.5vw !important;
    margin-right: 0.5vw !important;
  }
  .timerButtonIcon {
    width: 3.5vw;
    height: 3.5vw;
    font-size: 3.5vw !important;
  }
  .md-card>.md-card-area:not(:last-child):after {
    height: 0px;
  }
  .md-card-header {
    padding: 0px;
  }
  .md-card.cardBlindsCurrent {
    width: 100%;
    padding-top: 4vw;
    margin: 0px;
    box-shadow: none;
    text-align: center;
  }
  .md-tab {
    padding: 0px;
  }
  .currentBlindText {
    font-size: 5.5vw;
    line-height: 6vw;
    vertical-align: top;
  }
  .subBlindText {
    font-size: 2.6vw;
    line-height: 2.7vw;
    vertical-align: top;
  }
  .md-card.cardBlindsPrevious {
    width: 50%;
    padding-top: 2.1vw;
    margin: 0px;
    box-shadow: none;
    text-align: center;
    float: left;
  }
  .md-card.cardBlindsNext {
    width: 50%;
    padding-top: 2.1vw;
    margin: 0px;
    box-shadow: none;
    text-align: center;
    float: right;
  }
  .divBlindMessage {
    width: 100%;
    text-align: center;
    margin-top: 2.6vw;
    float: left;
    font-size: 2.6vw;
    line-height: 2.7vw;
    vertical-align: top;
  }
  .cardPlayers {
    padding-top: 1.04vw;
    margin: 0px !important;
    box-shadow: none;
    text-align: center;
    height: 32vw;
    display: block;
  }
  .cardHeadingToolbar {
    height: auto;
    min-height: 0px;
    text-align: center;
    justify-content: center;
  }
  .cellPlayer > .md-table-cell-container {
    padding: 0.31vw 0.26vw 0.31vw 0.26vw;
  }
  .cardPayouts {
    padding-top: 1.04vw;
    margin: 0px !important;
    box-shadow: none;
    text-align: center;
    float: left;
  }
  .payoutFillerCell {
    width: 25%;
    border: none !important;
  }
  .cardChipstacks {
    padding-top: 1.04vw;
    margin: 0px !important;
    box-shadow: none;
    text-align: center;
    float: right;
  }
  .playerButton {
    width: 2vw;
    height: 2vw;
    margin: 0px;
    min-width: 0px;
  }
  .playerButtonIcon {
    width: 1.25vw;
    height: 1.25vw;
    font-size: 1.25vw !important;
    min-width: 0px;
  }
  .playerHeader {
    font-size: 1.25vw !important;
  }
  .playerHeader > .md-table-head-container > .md-table-head-label {
    height: 1.45vw;
    padding-right: 1.66vw;
    padding-left: 1.25vw;
    display: inline-block;
    position: relative;
    line-height: 1.45vw;
    vertical-align: top;
  }
  .playerHeader > .md-table-head-container {
    height: 2.91vw;
    padding: 0.72vw 0;
  }
  .cellPlayer {
    font-size: 1.76vw;
    line-height: 2.1vw;
    height: 0px;
  }
  .payoutCell {
    font-size: 1.25vw;
    text-align: left;
    height: 0px;
  }
  .payoutCell > .md-table-cell-container {
    padding: 0.31vw 0.26vw 0.31vw 0.26vw;
  }
  .cellPlayerName {
    text-align: left;
  }
  .md-table .md-table-content {
    flex: 1 1 auto;
  }
  .leftVisible {
    display: inline-block;
    width: 100%;
    height: 45vw;
    overflow-y: hidden;
    overflow-x: hidden;
  }
  .leftHidden {
    display:none;
  }
</style>
